import React from 'react';
import { Route } from 'react-router-dom';
import WidgetsPageRoute from './WidgetsPageRoute';

const basePath = '/v2/widgets';

export default (
  <Route path={basePath}>
    <WidgetsPageRoute />
  </Route>
);
